module.exports = __webpack_public_path__ + "static/media/CompanyProfilebg@3x.93fd5417.png";